import React from 'react';

const MoqIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="12" viewBox="0 0 31 12" fill="none">
      <g clip-path="url(#a)">
        <path
          d="M27.175 12H1.56C.558 12-.182 11.076.034 10.118l2.05-8.912A1.57 1.57 0 0 1 3.608 0H29.44c1.013 0 1.765.946 1.514 1.915l-2.265 8.913A1.556 1.556 0 0 1 27.175 12"
          fill="#f38a3e"
        />
        <path
          d="M12.443 1.679 10.793 9.7H8.731l.398-1.96.774-3.02-2.72 4.98-1.355.012-.66-4.97-.49 3.065-.387 1.905h-2.05l1.651-7.978 2.232-.011.375-.011.581 5.216L9.824 1.7l.945-.011zm14.277.461a2.56 2.56 0 0 0-1.242-.574 4.1 4.1 0 0 0-3.438.969c-.751.653-1.263 1.543-1.525 2.49a9 9 0 0 0-.262 1.273c-.17 1.285.182 2.637 1.434 3.223.581.27 1.218.315 1.856.259l.57.552.466.45.398.384 1.572-1.127-.786-.744-.285-.27c.922-.665 1.526-1.623 1.845-2.682l.17-.743c.274-1.184.205-2.626-.774-3.46m-1.378 3.516c-.137.653-.308 1.284-.717 1.825-.365.485-.9.733-1.515.609-.546-.113-.74-.62-.774-1.138-.011-.282 0-.552.046-.823l.227-1.104c.057-.26.16-.507.274-.744.319-.665.842-1.172 1.616-1.115.49.034.774.304.9.766.148.54.034 1.16-.08 1.713zM17.976 1.69a3.6 3.6 0 0 0-.979-.146c-1.343-.023-2.55.62-3.358 1.667a5.1 5.1 0 0 0-.786 1.442c-.125.35-.205.688-.284 1.06a5.6 5.6 0 0 0-.137.98c-.046.879.148 1.791.808 2.4.342.315.752.53 1.218.63a4.03 4.03 0 0 0 2.983-.551c.888-.575 1.514-1.431 1.879-2.4a8 8 0 0 0 .307-1.127c.068-.36.137-.71.148-1.07.034-1.296-.49-2.468-1.787-2.874zm-.364 3.369a9 9 0 0 1-.262 1.25c-.148.519-.421 1.116-.831 1.477-.387.338-.91.45-1.389.281a.82.82 0 0 1-.478-.473c-.17-.394-.16-1.036-.068-1.465l.17-.856a4 4 0 0 1 .296-.879c.194-.417.478-.834.911-1.036a1.48 1.48 0 0 1 .91-.113c.798.158.843 1.127.74 1.814"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h31v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MoqIcon;
